<script setup lang="ts">
import { hideAllPoppers } from "floating-vue";
import { computed, nextTick, ref, watch } from "vue";

import DropdownMenu from "~/components/dumb/DropdownMenu.vue";
import { Placement } from "~/shared/enums";
import { useAppStore } from "~/stores";
import { makeDuid } from "~/utils/common";

const appStore = useAppStore();

const dropdown = ref<InstanceType<typeof DropdownMenu> | null>(null);
const key = ref(makeDuid());

watch(
  () => appStore.contextMenu,
  (contextMenu) => {
    if (contextMenu) {
      key.value = makeDuid();
      hideAllPoppers();
      nextTick(() => {
        dropdown.value?.open();
      });
    }
  }
);

const cursorReferenceNode = computed(() => {
  const { contextMenu } = appStore;
  if (!contextMenu || contextMenu.clientX === undefined || contextMenu.clientY === undefined) {
    return contextMenu?.node;
  }

  const { clientX, clientY } = contextMenu;

  return {
    getBoundingClientRect: () => new DOMRect(clientX, clientY, 0, 0),
  } as Element;
});
</script>

<template>
  <DropdownMenu
    ref="dropdown"
    :key="key"
    :reference-node="cursorReferenceNode"
    :sections="appStore.contextMenu?.sections ?? []"
    :distance="0"
    :skidding="0"
    :placement="Placement.RIGHT_TOP"
    :width-pixels="appStore.contextMenu?.widthPixels"
    :max-height-pixels="appStore.contextMenu?.maxHeightPixels" />
</template>
